import { render, staticRenderFns } from "./reception.vue?vue&type=template&id=00e9091c"
import script from "./reception.vue?vue&type=script&lang=js"
export * from "./reception.vue?vue&type=script&lang=js"
import style0 from "./reception.vue?vue&type=style&index=0&id=00e9091c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports